import React, { useEffect, useState } from 'react';
import { db } from '../../../../utils/firebase-config';
import { collection, getDocs } from "firebase/firestore";
import { surveySteps } from "../../Questions/Questions";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';
import { format } from 'date-fns';

const SavedAnswersPage = ({ handleNextStep, nextStep, userId, handlePreviousStep, setFormValues }) => {
  const [answers, setAnswers] = useState([]);
  const [expandedSection, setExpandedSection] = useState(null);

  useEffect(() => {
    const fetchAnswers = async () => {
      const collectionRef = collection(db, "users", userId, "Community_Minded_Business_Concept_Form");
      const querySnapshot = await getDocs(collectionRef);
      const data = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

      const filteredData = data.filter(submission => {
        const keys = Object.keys(submission);
        return keys.some(key => key !== 'createdAt' && key !== 'id');
      });

      const sortedData = filteredData.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
      setAnswers(sortedData);
    };

    fetchAnswers();
  }, [userId]);

  useEffect(() => {
    setFormValues({});
  }, [setFormValues]);

  const isImageUrl = (url) => {
    return /\.(jpeg|jpg|gif|png)$/.test(url);
  };

  const renderAnswers = () => {
    let logoRendered = false;

    return answers.map((submission, index) => (
      <div key={submission.id} className="accordion">
        <div
          className="step-answers mb-4 p-4 border border-gray-300 bg-white rounded-md cursor-pointer"
          onClick={() => setExpandedSection(expandedSection === submission.id ? null : submission.id)}
        >
          <h3 className="float-left text-xl font-semibold mb-2">
            Submission {index + 1} - {format(new Date(submission.createdAt), 'MMMM dd, yyyy HH:mm:ss')}
          </h3>
          <FontAwesomeIcon className="float-right" icon={expandedSection === submission.id ? faMinus : faPlus} />
          {expandedSection === submission.id && (
            <div>
              {surveySteps
                .filter(step => step.area === 'Community-Minded Business Concept Form')
                .map(step => (
                  step.stepTitle in submission && (
                    <div key={step.id} className="mt-2">
                      <hr className="my-5" />
                      <div className="font-bold text-xl">{step.stepTitle.replace(/_/g, ' ')}:</div>
                      {Object.entries(submission[step.stepTitle]).map(([question, answer], idx) => (
                        <div key={idx} className="mt-2">
                          <div>{question.replace(/_/g, ' ')}:</div>
                          {isImageUrl(answer) && !logoRendered ? (
                            <div>
                              <img src={String(answer)} alt="Uploaded" className="mt-2 w-full max-w-xs" />
                              {logoRendered = true}
                            </div>
                          ) : !isImageUrl(answer) ? (
                            <div className="overflow-hidden"><strong>{typeof answer === 'object' ? JSON.stringify(answer) : answer}</strong></div>
                          ) : null}
                        </div>
                      ))}
                    </div>
                  )
                ))}
            </div>
          )}
        </div>
      </div>
    ));
  };

  return (
    <div className="saved-answers-page">
      <h2 className="text-2xl font-bold mb-4">Review Your Answers</h2>
      {renderAnswers()}
      <div className="flex space-x-4">
        {nextStep && (
          <button
            className="mt-4 px-8 py-3 text-black border border-black font-semibold rounded-full hover:bg-amber-400 transition-colors"
            onClick={handleNextStep}
          >
            Continue
          </button>
        )}
        <button
          className="mt-4 px-8 py-3 text-black border border-black font-semibold rounded-full hover:bg-gray-400 transition-colors"
          onClick={handlePreviousStep}
        >
          Back
        </button>
      </div>
    </div>
  );
};

export default SavedAnswersPage;
